module.exports = __webpack_public_path__ + "static/media/placeholder.f95d5fb1.webp";